<template>
  <div class="mapWrapper">
    <div id="mapInfoBox">
    </div>
      <div ref="map" v-bind:style="{ width: width, height: height }"></div>
   </div>
</template>

<script>
/* global H */
import { bus } from '../../main'

let scriptCounter = 0

export default {
  name: 'Map',
  data () {
    return {
      msg: 'Karta',
      appCode: 'clMPTmhpQrJjfQnXXu_posxIz1Cl8Rcr_4na-rWGWws',
      map: {},
      platform: {},
      router: {},
      geocoder: {},
      directions: [],
      script: {
        core: {},
        corelegacy: {},
        service: {},
        servicelegacy: {},
        mapevents: {},
        ui: {},
        style: {}
      }
    }
  },
  props: {
    lat: String,
    lng: String,
    width: String,
    height: String,
    dataArray: Array,
    zoom: String,
    getGeoCoder: Boolean,
    customerPlace: Object,
    draggable: Boolean
  },
  created () {
  },
  async mounted () {
    if (scriptCounter === 0) {
      await this.addScript(document, 'core', this.script, 'https://js.api.here.com/v3/3.1/mapsjs-core.js')
      await this.addScript(document, 'service', this.script, 'https://js.api.here.com/v3/3.1/mapsjs-service.js')
      this.platform = new H.service.Platform({
        apikey: this.appCode
      })
      await Promise.all([
        this.addScript(document, 'mapevents', this.script, 'https://js.api.here.com/v3/3.1/mapsjs-mapevents.js'),
        this.addScript(document, 'ui', this.script, 'https://js.api.here.com/v3/3.1/mapsjs-ui.js'),
        this.addStylesheet(document, 'style', this.script, 'https://js.api.here.com/v3/3.1/mapsjs-ui.css')
      ])
    }
    scriptCounter++
    // eslint-disable-next-line
    var defaultLayers = this.platform.createDefaultLayers()
    // eslint-disable-next-line
    this.map = new H.Map(
      this.$refs.map,
      // eslint-disable-next-line
      defaultLayers.vector.normal.map,
      {
        center: { lat: 59.6749712, lng: 14.5208584 },
        zoom: 4,
        pixelRatio: window.devicePixelRatio || 1,
        padding: {top: 50, left: 50, bottom: 50, right: 50}
      }
    )
    // eslint-disable-next-line
    let behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map))
    // eslint-disable-next-line
    behavior.disable(H.mapevents.Behavior.WHEELZOOM)
    // eslint-disable-next-line
    this.ui = H.ui.UI.createDefault(this.map, defaultLayers)
    this.hereMapsFullScreenControl(this.ui)
    if (this.getGeoCoder && this.$props.dataArray.length === 1) {
      if (this.$props.dataArray[0].Latitude) {
        let locations = this.$props.dataArray
        this.addMarkersToMap(locations, behavior)
      } else {
        this.geocode(this.$props.dataArray[0].Address + ' ' + this.$props.dataArray[0].Postal + this.$props.dataArray[0].City, behavior)
      }
    } else {
      let locations = this.$props.dataArray
      this.addMarkersToMap(locations, behavior)
    }
  },
  destroyed () {
    scriptCounter--
    if (scriptCounter === 0) {
      this.delScript(document, 'core', this.script)
      this.delScript(document, 'corelegacy', this.script)
      this.delScript(document, 'service', this.script)
      this.delScript(document, 'servicelegacy', this.script)
      this.delScript(document, 'mapevents', this.script)
      this.delScript(document, 'ui', this.script)
      this.delStylesheet(document, 'style', this.script)
    }
  },
  methods: {
    addStylesheet (doc, name, scriptData, href) {
      return new Promise((resolve, reject) => {
        scriptData[name] = doc.createElement('link')
        scriptData[name].rel = 'stylesheet'
        scriptData[name].href = href
        scriptData[name].async = true
        scriptData[name].onload = resolve
        scriptData[name].onerror = reject
        doc.head.appendChild(scriptData[name])
      })
    },
    delStylesheet (doc, name, scriptData) {
      doc.head.removeChild(scriptData[name])
    },
    addScript (doc, name, scriptData, src) {
      return new Promise((resolve, reject) => {
        scriptData[name] = doc.createElement('script')
        scriptData[name].src = src
        scriptData[name].async = true
        scriptData[name].onload = resolve
        scriptData[name].onerror = reject
        doc.body.appendChild(scriptData[name])
      })
    },
    delScript (doc, name, scriptData) {
      doc.body.removeChild(scriptData[name])
    },
    geocode (address, behavior) {
      let url = `https://autosuggest.search.hereapi.com/v1/autosuggest?at=61.5946084,16.9364716&q=${address}&limit=1&apikey=${this.appCode}&lang=sv-SE`
      fetch(url)
        .then((res) => res.json())
        .then((data) => this.showGeoCode(data.items, behavior))
    },
    async showGeoCode (data, behavior) {
      let locations = []
      let info = '<div class="mapInfoWrapper"><p>' + this.$props.dataArray[0].Title + '</p><p>' + this.$props.dataArray[0].Address + '<br/>' + this.$props.dataArray[0].Postal + ' ' + this.$props.dataArray[0].City + '</p></div>'
      let title = this.$props.dataArray[0].Title
      let newLocation = {Data: info, Latitude: data[0].position.lat, Longitude: data[0].position.lng, Title: title}
      locations.push(newLocation)
      this.addMarkersToMap(locations, behavior)
    },
    onError () {
      console.log('Adressen kunde inte hittas')
    },
    AddMarkerToGroup (group, location, behavior) {
      var svgMarkup = '<svg xmlns="http://www.w3.org/2000/svg" width="28px" height="36px"> ' +
      '<path d="M 19 31 C 19 32.7 16.3 34 13 34 C 9.7 34 7 32.7 7 31 C 7 29.3 9.7 28 13 28 C 16.3 28 19 29.3 19 31 Z" ' +
      'fill="#000" fill-opacity=".2"/>' +
      '<path d="M 13 0 C 9.5 0 6.3 1.3 3.8 3.8 C 1.4 7.8 0 9.4 0 12.8 C 0 16.3 1.4 19.5 3.8 21.9 L 13 31 L 22.2 21.9 C 24.6 19.5 25.9 16.3 25.9 12.8 C 25.9 9.4 24.6 6.1 22.1 3.8 C 19.7 1.3 16.5 0 13 0 Z" ' +
      'fill="#fff"/><path d="M 13 2.2 C 6 2.2 2.3 7.2 2.1 12.8 C 2.1 16.1 3.1 18.4 5.2 20.5 L 13 28.2 L 20.8 20.5 C 22.9 18.4 23.8 16.2 23.8 12.8 C 23.6 7.07 20 2.2 13 2.2 Z" fill="#18d"/> ' +
      '<text x="13" y="15" font-size="4pt" font-family="Arial" font-weight="bold" text-anchor="middle" fill="#fff">' + location.Title + '</text></svg>'
      // eslint-disable-next-line
      var newIcon = new H.map.Icon(svgMarkup,{size: {w: 84, h: 108}})
      // eslint-disable-next-line
      var marker = new H.map.Marker({ lat: location.Latitude, lng: location.Longitude }, { icon: newIcon })
      marker.draggable = true
      marker.setData(location.Data)
      group.addObject(marker)
      if (this.$props.zoom === '' && this.dataArray.length > 1) {
        var bounds = group.getBoundingBox()
        this.map.getViewModel().setLookAtData({
          bounds: bounds
        })
      } else {
        this.map.setZoom(9)
        this.map.setCenter({lat: location.Latitude, lng: location.Longitude})
      }
      let that = this
      if (this.draggable) {
        this.map.addEventListener('dragstart', function (ev) {
          var target = ev.target
          var pointer = ev.currentPointer
          // eslint-disable-next-line
          if (target instanceof H.map.Marker) {
            var targetPosition = that.map.geoToScreen(target.getGeometry())
            // eslint-disable-next-line
            target['offset'] = new H.math.Point(pointer.viewportX - targetPosition.x, pointer.viewportY - targetPosition.y)
            behavior.disable(H.mapevents.Behavior.Feature.PANNING)
          }
        }, false)

        this.map.addEventListener('dragend', function (ev) {
          var target = ev.target
          // eslint-disable-next-line
          if (target instanceof H.map.Marker) {
            behavior.enable(H.mapevents.Behavior.Feature.PANNING)
            // eslint-disable-next-line
            behavior.disable(H.mapevents.Behavior.WHEELZOOM)
            if (that.$props.customerPlace) {
              that.$props.customerPlace.data.latitude = marker.getGeometry().lat
              that.$props.customerPlace.data.longitude = marker.getGeometry().lng
              bus.$emit('updateCustomerPlace', that.$props.customerPlace)
            }
            if (that.$props.dataArray && that.$props.dataArray.length === 1) {
              that.$props.dataArray[0].Latitude = marker.getGeometry().lat
              that.$props.dataArray[0].Longitude = marker.getGeometry().lng
              bus.$emit('updateObjectDataItem', that.$props.dataArray[0])
            }
          }
        }, false)
        this.map.addEventListener('drag', function (ev) {
          var target = ev.target
          var pointer = ev.currentPointer
          // eslint-disable-next-line
          if (target instanceof H.map.Marker) {
            target.setGeometry(that.map.screenToGeo(pointer.viewportX - target['offset'].x, pointer.viewportY - target['offset'].y))
          }
        }, false)
      }
    },
    addMarkersToMap (locations, behavior) {
      let that = this
      // eslint-disable-next-line
      let markerObjs = this.map.getObjects()
      markerObjs.forEach(function (obj) {
        if (obj) {
          that.map.removeObject(obj)
        }
      })
      // eslint-disable-next-line
      var group = new H.map.Group()
      this.map.addObject(group)
      var self = this
      group.addEventListener('tap', function (evt) {
        var bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
          content: evt.target.getData()
        })
        self.ui.addBubble(bubble)
      }, false)

      var addmarker = this.AddMarkerToGroup
      locations.forEach(function (location) {
        addmarker(group, location, behavior)
      })
    },
    hereMapsFullScreenControl (ui) {
      // add custom UI control
      // eslint-disable-next-line
      var myCustomControl = new H.ui.Control()
      myCustomControl.addClass('customControl')
      ui.addControl('myCustomControl', myCustomControl)
      // Set the position of the control in the UI's layout
      // eslint-disable-next-line
      myCustomControl.setAlignment(H.ui.LayoutAlignment.TOP_RIGHT)
      // eslint-disable-next-line
      var myCustomPanel = new H.ui.base.OverlayPanel()
      myCustomPanel.addClass('customPanel')
      myCustomControl.addChild(myCustomPanel)
      // store original styles
      var mapDiv = ui.getMap().getElement()
      var divStyle = mapDiv.style
      if (mapDiv.runtimeStyle) {
        divStyle = mapDiv.runtimeStyle
      }
      var originalPos = divStyle.position
      var originalWidth = divStyle.width
      var originalHeight = divStyle.height
      // ie8 hack
      if (originalWidth === '') {
        originalWidth = mapDiv.style.width
      }
      if (originalHeight === '') {
        originalHeight = mapDiv.style.height
      }
      var originalTop = divStyle.top
      var originalLeft = divStyle.left
      var originalZIndex = divStyle.zIndex
      var bodyStyle = document.body.style
      if (document.body.runtimeStyle) {
        bodyStyle = document.body.runtimeStyle
      }
      var originalOverflow = bodyStyle.overflow
      // eslint-disable-next-line
      var myCustomButton = new H.ui.base.PushButton({
        label: 'Fullskärm',
        onStateChange: function (evt) {
          // OK, button state changed... if it's currently down
          // eslint-disable-next-line
          if (myCustomButton.getState() === H.ui.base.Button.State.DOWN) {
            // go full screen
            mapDiv.style.position = 'fixed'
            mapDiv.style.width = '100%'
            mapDiv.style.height = '100%'
            mapDiv.style.top = '0'
            mapDiv.style.left = '0'
            mapDiv.style.zIndex = '100'
            document.body.style.overflow = 'hidden'
          } else {
            // exit full screen
            if (originalPos === '') {
              mapDiv.style.position = 'relative'
            } else {
              mapDiv.style.position = originalPos
            }
            mapDiv.style.width = originalWidth
            mapDiv.style.height = originalHeight
            mapDiv.style.top = originalTop
            mapDiv.style.left = originalLeft
            mapDiv.style.zIndex = originalZIndex
            document.body.style.overflow = originalOverflow
          }
          ui.getMap().getViewPort().resize()
        }
      })
      myCustomPanel.addChild(myCustomButton)
      // eslint-disable-next-line
      myCustomPanel.setState(H.ui.base.OverlayPanel.State.OPEN)
    }
  },
  watch: {
    dataArray: function (newVal, oldVal) {
      if (newVal.length > 0) {
        this.dataArray = newVal
        this.addMarkersToMap(newVal)
        // eslint-disable-next-line
        this.ui.getMap().getViewPort().resize()
      }
    },
    customerPlace: function (newVal, oldVal) {
      if (newVal.length > 0) {
        this.customerPlace = newVal
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Map/Map.vue